<div class="data-card-group" [class.compact]="isCompact">
  <ng-content></ng-content>
</div>
